import Tracked from '~/components/Tracked';
import useNavigationLinkInteraction from '~/hooks/useNavigationLinkInteraction';
import ColourCheckbox from '~/legacy/components/ColourCheckbox';
import type { CategoryListProps } from '~/legacy/types';
import type { TrackedButtonClickName } from '~/services/gtm.client';

const CategoryList = ({
  title,
  children,
  parentLink,
  isVertical = false,
  hideTrailingSlash = false,
  ancestorLabels = [title]
}: CategoryListProps) => {
  const fireNavigationLink = useNavigationLinkInteraction('meganav');

  return (
    <div className="main-header__sub-nav-list__categoryItem">
      <div className="main-header__sub-nav-list__categoryItem__title">
        {title}
      </div>
      {title !== 'Colour' &&
        children.map((item, i) => (
          <Tracked.ExternalLink
            href={`${parentLink}/${item.slug}/`}
            className="main-header__sub-nav-list__categoryItem__link"
            key={`${parentLink}/${item.slug}/`}
            name={item.name as TrackedButtonClickName}
            variant="none"
            pagePosition="Header"
            onClick={() =>
              fireNavigationLink(`${parentLink}/${item.slug}/`, i + 1, {
                ancestorLabels,
                label: item.name
              })
            }
          >
            {item.name}
          </Tracked.ExternalLink>
        ))}
      {title === 'Colour' && (
        <div
          className={`main-header__sub-nav-list__categoryItem__colour-list${
            isVertical ? '-vertical' : ''
          }`}
        >
          {children.map((item, i) => {
            const href = `${parentLink}/${item.slug}${!hideTrailingSlash ? '/' : ''}`;

            return (
              <Tracked.ExternalLink
                href={href}
                className="main-header__sub-nav-list__categoryItem__link"
                key={`${parentLink}/${item.slug}/`}
                name={item.name as TrackedButtonClickName}
                variant="none"
                pagePosition="Header"
                onClick={() =>
                  fireNavigationLink(href, i + 1, {
                    ancestorLabels,
                    label: item.name
                  })
                }
              >
                <div style={{ marginRight: '10px', marginTop: '5px' }}>
                  <ColourCheckbox isRefined={false} fill={item.colour} />
                </div>
                {item.name}
              </Tracked.ExternalLink>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CategoryList;
